export enum POST_HOG_EVENT {
  DUPLICATE_ACCOUNT = 'DUPLICATE ACCOUNT',
  STARTED_REGISTRATION_LEGACY = 'Started Registration (Legacy)',
  VIEW_PASSWORD_LEGACY = 'View Password Screen (Legacy)',
  MARKETING_LEGACY = 'Marketing Screen (Legacy)',
  T_C_LEGACY = 'T+Cs Screen (Legacy)',
  PERSONAL_DETAILS_LEGACY = 'Personal Information Screen (Legacy)',
  POSTCODE_LEGACY = 'Postcode Screen (Legacy)',
  ADDRESS_LEGACY = 'Address Screen (Legacy)',
  PHONE_LEGACY = 'Phone Number Screen (Legacy)',
  VERIFY_LEGACY = 'Verify Identity Screen (Legacy)',
  DEPOSIT_LIMIT_LEGACY = 'Deposit Limit Screen (Legacy)',
  FIRST_DEPOSIT_LEGACY = 'First Deposit Screen (Legacy)',
  FIRST_DEPOSIT_SUCCESS_LEGACY = 'First Deposit Success (Legacy)',

  STARTED_REGISTRATION = 'Started Registration',
  PERSONAL_DETAILS = 'Personal Details Screen',
  EMAIL_SUCCESSFULLY_VALIDATED_BY_POSTCODER = 'Email Successfully Validated',
  EMAIL_REJECTED_BY_POSTCODER = 'Email Rejected',
  COMPLETED_REGISTRATION = 'Completed Registration',
  DEPOSIT_LIMITS = 'Deposit Limits Screen',
  FIRST_DEPOSIT = 'First Deposit Screen',
  SKIPPED_FIRST_DEPOSIT = 'Skipped First Deposit',
  FAILED_FIRST_DEPOSIT = 'Failed First Deposit',
  SUCCESS_FIRST_DEPOSIT = 'Successful First Deposit',

  ADD_BET_FEATURED_PAGE = 'Added Bet from Featured Page',
  ADD_TRENDING_BET_FEATURED_PAGE = 'Added Trending Bet from Featured Page',
  ADD_BET_EVENT_LIST = 'Added Bet from Event List',
  ADD_BET_EVENT_DETAIL = 'Added Bet from Event Detail',
  ADD_BET_TRENDING = 'Added Trending Bet from Betslip',
  PLACED_SINGLE_BET = 'Placed Single Bet',
  PLACED_ACCA_BET = 'Placed Accumulator Bet',
  PLACED_MULTI_BET = 'Placed Multi Bet',
  ADD_RACING_BET_FEATURED_PAGE = 'Added Racing Bet from Featured Page',
  ADD_RACING_BET_EVENT_LIST = 'Added Racing Bet from Event List',
  ADD_RACING_BET_EVENT_DETAIL = 'Added Racing Bet from Event Detail',

  LOADED_CASINO_GAME = 'Loaded Casino Game',
  CASINO_GAME_OPENED_FROM_SEARCH = 'Casino Game Opened from Search',
  CASINO_GAME_OPENED_FROM_FILTER = 'Casino Game Opened from Filter',
  CASINO_GAME_OPENED_FROM_INSTANT_GAMES = 'Casino Instant Game Opened',
  CASINO_GAME_OPENED_FROM_SPORTSBOOK_FEATURED = 'Casino Game Opened from Sports Featured Page',

  OPEN_BESPOKE_CASINO_GAME_FEATURED = 'Opened Bespoke Casino Game Featured',
  OPEN_BESPOKE_CASINO_GAME_SLOTS = 'Opened Bespoke Casino Game Slots',
  OPEN_BESPOKE_CASINO_GAME_LIVE_CASINO = 'Opened Bespoke Casino Game Live Casino',
  OPEN_BESPOKE_CASINO_GAME_TABLE_GAMES = 'Opened Bespoke Casino Game Table Games',
  OPEN_BESPOKE_CASINO_GAME_VIRTUAL_SPORTS = 'Opened Bespoke Casino Game Virtual Sports',
  OPEN_BESPOKE_CASINO_GAME_UNTRACKED_CATEGORY = 'Opened Untracked Bespoke Casino Game',

  OPEN_BESPOKE_COMPETITION = 'Opened Bespoke Competition',

  DEPOSIT_CUSTOM_AMOUNT = 'Deposit Custom Amount',

  DOCUMENT_SUMMARY_PAGE = 'Document Summary Page',
  DOCUMENT_SUCCESSFUL_UPLOAD = 'Document Successful Upload',
  DOCUMENT_FAILED_UPLOAD = 'Document Failed Upload',

  CASINO_LIVE_SUB_TAB_CLICK = 'Clicked Sub Tab Filter From Live Casino',

  SUBMITTED_NET_PROMOTER_SCORE = 'Submitted Net Promoter Score',
  SURVEY_SENT = 'survey sent', // this is a defined event via posthog - cannot give other name

  TOUR_DO_NO_SHOW_AGAIN = "Tour Don't Show Again",
  VIEWED_TOUR_STEP_1 = 'Viewed Tour Step 1',
  VIEWED_TOUR_STEP_2 = 'Viewed Tour Step 2',
  VIEWED_TOUR_STEP_3 = 'Viewed Tour Step 3',
  VIEWED_TOUR_STEP_4 = 'Viewed Tour Step 4',
  VIEWED_TOUR_STEP_5 = 'Viewed Tour Step 5',
  VIEWED_TOUR_STEP_6 = 'Viewed Tour Step 6',
  VIEWED_TOUR_STEP_7 = 'Viewed Tour Step 7',
  VIEWED_TOUR_STEP_8 = 'Viewed Tour Step 8',
  VIEWED_TOUR_STEP_9 = 'Viewed Tour Step 9',
  VIEWED_TOUR_STEP_10 = 'Viewed Tour Step 10',

  STREAM_FEATURED = 'Opened Stream from Featured',
  STREAM_SPORT = 'Opened Sport Specific Stream',
  STREAM_MY_BETS = 'Opened Stream from MyBets',

  MY_PROMOTIONS_PROFILE = 'Opened My Promotions From Profile',
  MY_PROMOTIONS_SIGN_UP_MARKETING_WIDGET = 'Opened My Promotions From Sign Up Marketing Widget',
  MY_PROMOTIONS_SIDE_NAV_BAR = 'Opened My Promotions From Side Nav Bar',
}

export enum POSTHOG_FEATURE_FLAG_VALUE {
  TEST = 'test',
  CONTROLLED = 'controlled',
}

export enum POSTHOG_FEATURE_FLAG_KEY {
  NET_PROMOTER_SCORE = 'nps',
  CASINO_FILTER_REORDER = 'casino-filter-reorder',
  BET_PLACEMENT_PLACE_ANIMATION = 'rocket',
}

export enum POSTHOG_SURVEY_RESPONSE_STATUS {
  RESPONDED = 'responded',
  NOT_RESPONDED = 'not_responded',
}
